"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var STATE_REGISTRY_TOPIC;
(function (STATE_REGISTRY_TOPIC) {
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["EVENT_SUBSCRIPTIONS"] = 11] = "EVENT_SUBSCRIPTIONS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["RECORD_SUBSCRIPTIONS"] = 12] = "RECORD_SUBSCRIPTIONS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["SUBSCRIPTIONS"] = 9] = "SUBSCRIPTIONS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["ONLINE_USERS"] = 10] = "ONLINE_USERS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["MONITORING_SUBSCRIPTIONS"] = 24] = "MONITORING_SUBSCRIPTIONS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["RPC_SUBSCRIPTIONS"] = 13] = "RPC_SUBSCRIPTIONS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["PRESENCE_SUBSCRIPTIONS"] = 14] = "PRESENCE_SUBSCRIPTIONS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["RECORD_LISTEN_PATTERNS"] = 15] = "RECORD_LISTEN_PATTERNS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["EVENT_LISTEN_PATTERNS"] = 16] = "EVENT_LISTEN_PATTERNS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["RECORD_PUBLISHED_SUBSCRIPTIONS"] = 17] = "RECORD_PUBLISHED_SUBSCRIPTIONS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["EVENT_PUBLISHED_SUBSCRIPTIONS"] = 18] = "EVENT_PUBLISHED_SUBSCRIPTIONS";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["RECORD_LISTENING"] = 19] = "RECORD_LISTENING";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["EVENT_LISTENING"] = 20] = "EVENT_LISTENING";
    STATE_REGISTRY_TOPIC[STATE_REGISTRY_TOPIC["STATE_REGISTRY"] = 21] = "STATE_REGISTRY";
})(STATE_REGISTRY_TOPIC = exports.STATE_REGISTRY_TOPIC || (exports.STATE_REGISTRY_TOPIC = {}));
var STATE_ACTION;
(function (STATE_ACTION) {
    STATE_ACTION[STATE_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    STATE_ACTION[STATE_ACTION["ERROR"] = 1] = "ERROR";
    STATE_ACTION[STATE_ACTION["ADD"] = 2] = "ADD";
    STATE_ACTION[STATE_ACTION["REMOVE"] = 3] = "REMOVE";
    STATE_ACTION[STATE_ACTION["REQUEST_FULL_STATE"] = 4] = "REQUEST_FULL_STATE";
    STATE_ACTION[STATE_ACTION["FULL_STATE"] = 5] = "FULL_STATE";
    STATE_ACTION[STATE_ACTION["CHECKSUM"] = 6] = "CHECKSUM";
})(STATE_ACTION = exports.STATE_ACTION || (exports.STATE_ACTION = {}));
//# sourceMappingURL=state.js.map